export const SET_COMPANY_BY_BUSINESS_UNIT = 'SET_COMPANY_BY_BUSINESS_UNIT';
